<template>
  <a @click="setActive" v-bind:href="href" class="nav-link" :class="{active: active}" tabindex="-1">
    <span class="icon">
             <div v-if="badgeCount > 0" class="badge badge--small badge--translucent">
              {{ badgeCount }}
            </div>
        <slot/>
    </span>

    <span class="tool-tip">
      {{ title }}
    </span>
  </a>
</template>

<script>
export default {
  name: "NavLink.vue",
  emits: ['link-click'],
  data() {
    return {
      active: false,
      currentUrl: location.href
    }
  },
  mounted() {
    this.setActive();
    setInterval(() => {
      if (location.href !== this.currentUrl) {
        this.currentUrl = location.href;
        this.setActive();
      }
    }, 500);
  },
  methods: {
    setActive() {
      this.$emit('link-click');
      const isCurrentLocation = window.location.pathname === this.href;
      const isDefaultDashboardRoute = window.location.pathname === '/dashboard' && this.href === '/dashboard/customers';
      this.active = isCurrentLocation || isDefaultDashboardRoute;
    }
  },
  props: {
    href: {
      type: String,
      required: false,
      default: () => undefined,
    },
    title: {
      type: String,
      required: true,
    },
    badgeCount: {
      type: [Number, String],
      required: false,
    },
  },
}
</script>
<style lang="scss" scoped>
@import "~@/_default.scss";

.icon {
  height: 1em;
  width: 1em;
  position: relative;
}

.badge {
  position: absolute;
  top: -10px;
  right: -10px;
  z-index: 10;
  font-size: $font-size-small;
}

.nav-link {
  position: relative;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    .tool-tip {
      opacity: 1;
    }
    .badge {
      background-color: $brand-danger;
    }
  }
  &:focus {
    svg{
      fill: lighten($blue-lighter, 25%);
    }
  }

}

.tool-tip {
  transition: $transition-base;
  z-index: 100;
  opacity: 0;
  position: absolute;
  top: 0;
  margin-top: $navbar-height;
  left: 50%;
  transform: translateX(-50%);
  margin-left: auto;
  margin-right: auto;
  min-width: 2rem;
  padding: $spacing-xs;
  border-radius: $border-radius-small;
  background-color: rgba(0, 0, 0, 0.8);
  font-size: $font-size-small;
  color: white;
  /* Only display on icon hover */
  pointer-events: none;
}

.tool-tip::after {
  content: " ";
  position: absolute;
  /* -5px chevron + -5px border */
  top: -9px;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent rgba(0, 0, 0, 0.6) transparent;
}



.badge {
  transition: $transition-base;
  background-color: transparentize($brand-danger, 0.15);
}

</style>

<style lang="scss">
@import "~@/_default.scss";
.nav-link {
  svg {
    fill: rgba(255, 255, 255, 0.8) !important;
    width: $spacing-md !important;
    height: $spacing-md !important;
  }
  &.active,
  &:hover{
    svg {
      fill: white !important;
    }
  }

}
</style>
